"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var tld = 'authereum.com';
exports.defaultConfig = {
  xsUri: function xsUri(network) {
    var s = network === 'mainnet' ? '' : "".concat(network, ".");
    return "https://".concat(s, "x.").concat(tld);
  }
};